import React from "react";
import { View, StyleSheet } from "react-native";
import { PlusCircle } from "@phosphor-icons/react";

import CustomText from "../../common/general/CustomText/CustomText";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../../common/general/CustomButton/CustomButton";

interface DegreesHeaderProps {
  totalCount: number;
  onAddDegree: () => void;
}

const DegreesHeader: React.FC<DegreesHeaderProps> = ({ totalCount, onAddDegree }) => {
  return (
    <View>
      <CustomText
        text="Manage Degrees"
        textType="display"
        weight="ultraBold"
        role="heading"
        aria-level="1"
        style={{ color: "#101828" }}
      />

      <CustomSpacing size="s" />

      <CustomText
        text="Create, edit, and manage degree programs and their associated courses."
        style={{ color: "#667085" }}
      />

      <CustomSpacing size="xl" />

      <View style={styles.headerRow}>
        <View style={styles.totalCountContainer}>
          <CustomText style={{ color: "#101828" }} size="l" weight="bold" text="Total Degrees" />
          <CustomText
            style={{ color: "#101828" }}
            size="l"
            weight="bold"
            text={`(${totalCount})`}
            useTranslationText={false}
          />
        </View>

        <View style={styles.addButtonContainer}>
          <CustomButton
            testID="add-degree-button"
            styleType="primary"
            bold={true}
            text="Add a Degree"
            leftIcon={<PlusCircle size={24} color={"#FFFFFF"} />}
            onPress={onAddDegree}
          />
        </View>
      </View>

      <CustomSpacing size="xl" />
    </View>
  );
};

const styles = StyleSheet.create({
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  totalCountContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  addButtonContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
});

export default DegreesHeader;
